import type {CanvasRect, RemoteSession} from '@PosterWhiteboard/collaboration/poster-presence.types';
import type {RemoteSelectionOutline} from './page-presence-layer.types';

/**
 * The session's selected items measured from this editor's Fabric objects, so the outline sits on
 * the item as this viewer has it and moves only when the other editor's edit is applied here.
 * `itemTransformVersion` is taken only so the caller's result follows every move, scale, rotate
 * and applied remote edit.
 */
export const getRemoteSelectionOutlines = (session: RemoteSession, itemTransformVersion: number): RemoteSelectionOutline[] => {
  return measureItemOutlines(session.selectedItemIds, itemTransformVersion);
};

/** The rectangle around every outline, where the selection's name pill sits; null for an empty selection. */
export const getOutlinesBounds = (outlines: RemoteSelectionOutline[]): CanvasRect | null => {
  if (outlines.length === 0) {
    return null;
  }
  const left = Math.min(...outlines.map((outline) => outline.left));
  const top = Math.min(...outlines.map((outline) => outline.top));
  const right = Math.max(...outlines.map((outline) => outline.left + outline.width));
  const bottom = Math.max(...outlines.map((outline) => outline.top + outline.height));
  return {left, top, width: right - left, height: bottom - top};
};

const measureItemOutlines = (itemIds: string[], _itemTransformVersion: number): RemoteSelectionOutline[] => {
  const outlines: RemoteSelectionOutline[] = [];
  for (const itemId of itemIds) {
    const item = window.posterEditor?.whiteboard?.getItemForId(itemId);
    if (item === undefined) {
      continue;
    }
    const {left, top, width, height} = item.fabricObject.getBoundingRect();
    outlines.push({itemId, left, top, width, height});
  }
  return outlines;
};
